import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Инициализируем i18n
import './locales/i18n';

// Стили
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
